import React, { useState, useEffect, useMemo } from "react";
import { Form, Button, Row, Col, Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import SelectImport from "react-select";
import AdminApi from "../../api/adminApi";
import AuthApi from "../../api/authApi";
import { formatParishOptionLabel, sortParishesByName } from "../../utils/parishLabels";
import { useAuthUser } from "../../hooks/useAuthUser";

import DeleteModel from "../../components/DeleteModal";
import AlertModal from "../../components/AlertModal";
import RetreatApi from "../../api/retreatApi";
import CommitteeApi from "../../api/committeeApi";
import MasterPageShell from "../../components/masterData/MasterPageShell";
import MasterSearchField from "../../components/masterData/MasterSearchField";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import moment from "moment";
import {
  Building2,
  Info,
  Mail,
  MapPin,
  Plus,
  Shield,
  Trash2,
  Users,
} from "lucide-react";
import styles from "./AdminDashboard.module.scss";

const FormSelect = Form.Select as any;
const Select = SelectImport as any;

const ADMIN_TAB_BY_HASH: Record<string, string> = {
  "#steering-committee": "steeringCommittee",
  "#super-admins": "superAdmins",
  "#sub-admins": "subAdmins",
  "#retreat-sub-admins": "retreatSubAdmins",
};

// Custom MultiValueRemove component to hide "x"
const CustomMultiValueRemove = (props: any) => null;

const textMatch = (value: any, query: string) =>
  String(value || "").toLowerCase().includes(query);

const getInitials = (first?: string, last?: string, name?: string) => {
  const fromParts = `${(first || "").trim().charAt(0)}${(last || "")
    .trim()
    .charAt(0)}`;
  if (fromParts.trim()) return fromParts.toUpperCase();
  const fromName = (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("");
  return (fromName || "?").toUpperCase();
};

const formatRetreatDates = (from: any, to: any) => {
  if (!from || !to) return "";
  if (moment(from).isSame(to, "day")) {
    return `${moment(from).format("MMM D, YYYY")}`;
  }
  if (moment(from).isSame(to, "month")) {
    return `${moment(from).format("MMM D")} - ${moment(to).format("D")}, ${moment(from).format("YYYY")}`;
  }
  return `${moment(from).format("MMM D")} - ${moment(to).format("MMM D")}, ${moment(from).format("YYYY")}`;
};

const AdminDashboard = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [mailId, setMailId] = useState<any>(null);
  const [removeId, setRemoveId] = useState<any>(null);
  const [allcouple, setAllcouple] = useState<any[]>([]);
  const [allAdminList, setAllAdminList] = useState<any[]>([]);
  const [allSubAdminList, setAllSubAdminList] = useState<any[]>([]);
  const [showAccessAlert, setShowAccessAlert] = useState(false);
  const [coupleSelectAdmin, setCoupleSelectAdmin] = useState<any>(null);
  const [removeAccessShow, setRemoveAccessShow] = useState(false);
  const [retAdminAccessAlert, setRetAdminAccessAlert] = useState(false);
  const [coupleSelectSubAdmin, setCoupleSelectSubAdmin] = useState<any>(null);
  const [allRetreatSubAdminList, setAllRetreatSubAdminList] = useState<any[]>([]);
  const [showMailAlert, setShowMailAlert] = useState(false);
  const [myRoleIs, setMyRoleIs] = useState<any>(null);
  const [showRegModal, setShowREgModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [retreatOptions, setRetreatOptions] = useState<any[]>([]);
  const [selectedRetreats, setSelectedRetreats] = useState<any[]>([]);
  const [loadData, setLoadData] = useState(false);
  const [allCommittee, setAllCommittee] = useState<any[]>([]);
  const [deleteMember, setDeleteMember] = useState(false);
  const [alert, setAlert] = useState(false);
  const [member, setMember] = useState<any>("");
  const [show5, setShow5] = useState(false);
  const [parishList, setParishList] = useState<any[]>([]);
  const [allRetreats, setAllRetreats] = useState<any[]>([]);
  const [selecterdCommittee, setSelecterdCommittee] = useState<any>("");
  const [selectUserCheck, setSelectUserCheck] = useState(false);
  const [selectedEditRetreats, setSelectedEditRetreats] = useState<any[]>([]);
  const [openModalFor, setOpenModalFor] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [data, setData] = useState<any>({
    id: "",
    parishId: null,
    retreats: [],
    userId: [],
  });

  let committeeApi = new CommitteeApi();
  let adminApi = new AdminApi();
  let retreatApi = new RetreatApi();
  let authApi = new AuthApi();
  const userData = useAuthUser();
  const [cookie, setCookie] = useCookies(["LoveStrongUser"]);
  const resolveAdminTab = () =>
    ADMIN_TAB_BY_HASH[location.hash] ||
    (location.state as any)?.adminTab ||
    "steeringCommittee";
  const [activeTab, setActiveTab] = useState(resolveAdminTab);

  useEffect(() => {
    setActiveTab(resolveAdminTab());
    setSearchQuery("");
  }, [location.hash, location.state]);

  useEffect(() => {
    getAllCouples();
    adminsAndSubAdmins();
    getAllretreatSubAdmins();
    allCommitteMembers();
    getAllRetreats();
    getParishList();
  }, []);

  const adminsAndSubAdmins = async () => {
    await adminApi
      .geAdminsAndSubAdmins()
      .then(async (res: any) => {
        if (res.success) {
          if (res.admins) {
            setAllAdminList(res.admins);
          }
          if (res.subAdmins) {
            setAllSubAdminList(res.subAdmins);
          }
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getAllretreatSubAdmins = async () => {
    await retreatApi
      .allretreatSubAdmins({} as any)
      .then(async (res: any) => {
        if (res.success) {
          setAllRetreatSubAdminList(res.data);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getAllCouples = async () => {
    await adminApi
      .allCouples()
      .then(async (res: any) => {
        if (res.success) {
          let Allcouple = [];
          res.data &&
            res.data.forEach((item) => {
              if (item.hisEmail) {
                Allcouple.push({
                  label: `${item.hisFirstName} ${item.hisLastName} (${item.hisEmail})`,
                  value: item.hisEmail,
                });
              }
              if (item.herEmail) {
                Allcouple.push({
                  label: `${item.herFirstName} ${item.herLastName} (${item.herEmail})`,
                  value: item.herEmail,
                });
              }
            });
          setAllcouple(Allcouple);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const handleSelectOption = (val: any, selection: any) => {
    if (selection === "forAdmins") {
      setCoupleSelectAdmin(val);
    } else {
      setCoupleSelectSubAdmin(val);
    }
  };

  const handleSelectSubmit = async () => {
    let submitData = null;
    if (coupleSelectAdmin && Object.keys(coupleSelectAdmin).length > 0) {
      submitData = {
        role: "ADMIN",
        email: coupleSelectAdmin.value,
      };
    }
    if (coupleSelectSubAdmin && Object.keys(coupleSelectSubAdmin).length > 0) {
      submitData = {
        role: "SUBADMIN",
        email: coupleSelectSubAdmin.value,
      };
    }
    if (submitData) {
      try {
        const res = await adminApi.updateUserRole(submitData);
        if (res.success) {
          setCoupleSelectSubAdmin([]);
          setCoupleSelectAdmin([]);
          toast.success(res.msg);
          adminsAndSubAdmins();
        } else {
          toast.error(res.msg);
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      toast.error("Please select data from dropdown.");
    }
  };

  const handleShow = (i: any, check: any) => {
    setRemoveId(i);
    setShow(true);
    setMyRoleIs(check);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleShowOfAccess = (retreatData: any, removed_mail: any) => {
    setRemoveId(retreatData);
    setMailId(removed_mail);
    setRemoveAccessShow(true);
  };

  const handleCloseOfAccess = () => {
    setRemoveAccessShow(false);
  };

  const removeRole = () => {
    adminApi
      .removeUserRole({
        removeId: removeId.id,
      })
      .then((res: any) => {
        adminsAndSubAdmins();
        toast.success(res.msg);
        setRemoveId([]);
        handleClose();
      })
      .catch((error: any) => {
        console.error(error);
        toast.error(error);
      });
  };

  const removeAccessFromRetreat = () => {
    // Combine array elements into a single object
    retreatApi
      .removeAccessFromRetreat({
        remove_access_mail: mailId,
        retreatId: removeId.id,
      })
      .then((res: any) => {
        // Check if response has a message
        if (res.msg) {
          toast.success(res.msg);
        } else {
          toast.success("Access removed successfully");
        }
        getAllretreatSubAdmins();
        setMailId([]);
        handleCloseOfAccess();
      })
      .catch((error: any) => {
        console.error(error);
        toast.error("An error occurred while removing access");
      });
  };

  const handleShowAlert = (event: any, item: any) => {
    let { name, value } = event.target;
    setRemoveId(item);
    setShowAccessAlert(true);
  };

  const handleCloseAlert = () => {
    setShowAccessAlert(false);
  };

  const adminAccess = () => {
    adminApi
      .changeAdminAccess({
        id: removeId.id,
        isDisabled: removeId.isDisabled,
      })
      .then((res: any) => {
        adminsAndSubAdmins();
        toast.success(res.msg);
        setRemoveId([]);
        handleCloseAlert();
      })
      .catch((error: any) => {
        console.error(error);
        toast.error(error);
      });
  };

  const showRetreatAdminAlert = (retreat: any, UserData: any) => {
    setRemoveId(UserData);
    setMailId(retreat.id);
    setRetAdminAccessAlert(true);
  };

  const closeretAdminAlert = () => {
    setRetAdminAccessAlert(false);
  };

  const sendLoginDetail = () => {
    adminApi
      .sendLoginDetail({ myData: removeId, myRole: myRoleIs })
      .then((res: any) => {
        if (res.success) {
          toast.success(res.msg);
          handleClose2();
        } else {
          toast.error(res.msg);
          handleClose2();
        }
      })
      .catch((error: any) => {
        console.error(error);
        toast.error(error);
        handleClose2();
      });
  };

  const retreatAdminAccess = () => {
    retreatApi
      .retreatAdminAccess({
        userId: removeId.id,
        retreatId: mailId,
        checkAccess: removeId.isDisabled,
      })
      .then((res: any) => {
        getAllretreatSubAdmins();
        toast.success(res.msg);
        setRemoveId([]);
        setMailId([]);
        closeretAdminAlert();
      })
      .catch((error: any) => {
        console.error(error);
        toast.error(error);
      });
  };

  const handleShow2 = (item: any, check: any) => {
    setMyRoleIs(check);
    setShowMailAlert(true);
    setRemoveId(item);
  };

  const handleClose2 = () => {
    setShowMailAlert(false);
    setRemoveId([]);
    setMyRoleIs(null);
  };

  const getAllRetreats = async () => {
    try {
      const response = await retreatApi.getAllRetreatSearch({} as any);
      const sortedList = response.data.sort((a, b) =>
        (a?.title ?? "").localeCompare(b?.title ?? "")
      );
      setAllRetreats(sortedList);
      let retreatList = sortedList.map((item) => ({
        label: item.title
          ? `${item?.parishName || ""}${item.language
            ? ` (${item.language[0].toUpperCase()}${item.language.slice(
              1
            )})`
            : ""
          } ${item.location
            ? `${item.location[0].toUpperCase()}${item.location.slice(1)} `
            : ""
          } ${moment(item.dateFrom).format("MMM DD") +
          " - " +
          moment(item.dateTo).format("MMM DD") +
          ", " +
          moment(item.dateFrom).format("YYYY")
          }`
          : "",
        value: item.id,
        dateFrom: moment(item.dateFrom),
        disabled: false,
        parishId: item.parishId,
      }));
      setRetreatOptions(retreatList);
    } catch (error) {
      toast.error(error.toString());
    }
  };

  const clearfield = () => {
    setData({
      id: "",
      parishId: null,
      retreats: [],
      userId: [],
    });
    setSelecterdCommittee("");
    setSelectedRetreats([]);
    setValidated(false);
    setSelectedEditRetreats([]);
    getAllRetreats();
    setOpenModalFor("");
  };

  const handleSelectRetreat = (selectedOptions: any) => {
    if (data.parishId && data.parishId !== null) {
      const validOptions = selectedOptions.filter((option) =>
        retreatOptions.some((ro) => ro.value === option.value)
      );

      setSelectedRetreats(validOptions);
      const newRetreats = validOptions.map((option) => ({
        retreatId: option.value,
        disabled: option.disabled,
      }));
      const editRetreats = (selectedEditRetreats || []).map((option) => ({
        retreatId: option.value,
        disabled: option.disabled,
      }));
      const mergedRetreatsMap = new Map();
      [...editRetreats, ...newRetreats].forEach((r) => {
        mergedRetreatsMap.set(r.retreatId, r);
      });
      const mergedRetreats = Array.from(mergedRetreatsMap.values());
      setData((prev) => ({
        ...prev,
        retreats: mergedRetreats,
      }));
    } else {
      toast.error("Please select a parish first.");
    }
  };

  const handleSelectUserId = (val: any) => {
    setSelecterdCommittee(val);
    let a = data;
    a.userId = val;
    setData(a);
  };

  const handleChanges = (e: any) => {
    let { name, value } = e.target;

    if (name === "parishId") {
      const filteredList = allRetreats.filter((item) => item.parishId == value);
      const selectedIds = selectedEditRetreats.map((r) => r.value);

      let retreatList = filteredList
        .filter((item) => !selectedIds.includes(item.id))
        .map((item) => ({
          label: item.title
            ? `${item?.parishName || ""}${item.language
              ? ` (${item.language[0].toUpperCase()}${item.language.slice(
                1
              )})`
              : ""
            } ${item.location
              ? `${item.location[0].toUpperCase()}${item.location.slice(
                1
              )} `
              : ""
            } ${moment(item.dateFrom).format("MMM DD") +
            " - " +
            moment(item.dateTo).format("MMM DD") +
            ", " +
            moment(item.dateFrom).format("YYYY")
            }`
            : "",
          value: item.id,
          dateFrom: moment(item.dateFrom),
          disabled: false,
          parishId: item.parishId,
        }));
      setRetreatOptions(retreatList);
      setSelectedRetreats(retreatList);
      const validOptions = retreatList.filter((option) =>
        retreatList.some((ro) => ro.value === option.value)
      );

      const newRetreats = validOptions.map((option) => ({
        retreatId: option.value,
        disabled: option.disabled,
      }));

      const editRetreats = (selectedEditRetreats || []).map((option) => ({
        retreatId: option.value,
        disabled: option.disabled,
      }));

      const mergedRetreatsMap = new Map();
      [...editRetreats, ...newRetreats].forEach((r) => {
        mergedRetreatsMap.set(r.retreatId, r);
      });
      const mergedRetreats = Array.from(mergedRetreatsMap.values());
      setData((prev) => ({
        ...prev,
        retreats: mergedRetreats,
        parishId: value,
      }));

      return;
    }
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      try {
        let data1 = new FormData();
        let stateRef = { ...data };
        data1.append("fromData", JSON.stringify(stateRef));
        if (openModalFor === "NewSteeringMember") {
          committeeApi
            .newSteeringMember(data1)
            .then(async (res: any) => {
              if (res.success) {
                toast.success(res.msg);
                clearfield();
                setShowREgModal(false);
                allCommitteMembers();
              } else {
                toast.error(res.msg);
              }
            })
            .catch((error: any) => {
              console.log(error);
            });
        } else {
          committeeApi
            .createCommitteeMember(data1)
            .then(async (res: any) => {
              if (res.success) {
                userData.committeeMember = true;
                setCookie("LoveStrongUser", userData, {
                  path: "/",
                  maxAge: 60 * 60 * 100,
                  expires: new Date(Date.now() + 60 * 60 * 100),
                });
                if (data.id) {
                  
                } else {
                  
                }

                toast.success(res.msg);
                clearfield();
                setShowREgModal(false);
                allCommitteMembers();
              } else {
                toast.error(res.msg);
              }
            })
            .catch((error: any) => {
              console.log(error);
            });
        }
      } catch (err) {
        toast.error("Error submitting data.");
      }
    }
    setValidated(true);
  };

  const allCommitteMembers = async () => {
    setLoadData(true);
    await committeeApi
      .getAllCommitteMembers({} as any)
      .then((res: any) => {
        if (res.success) {
          setLoadData(false);
          setAllCommittee(res.data);
        } else {
          setLoadData(false);
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        setLoadData(false);
        toast.error(error);
      });
  };

  const deleteMemberPopUpOpen = (userData: any, parishData: any) => {
    setDeleteMember(true);
    setMember({ userData: userData, parishData: parishData });
  };

  const deleteMemberPopUpClose = () => setDeleteMember(false);

  const deleteMemberFun = async () => {
    await committeeApi
      .deleteMember({
        userId: member?.userData?.userId,
        parishId: member?.parishData?.parishId,
      })
      .then(async (res) => {
        if (res.success) {
          allCommitteMembers();
          setShow(false);
          setMember("");
          deleteMemberPopUpClose();
          toast.success(res.msg);
          
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const handleShow3 = (retreat, parishdata) => {
    setMember({ retreat: retreat, parishId: parishdata.parishId });
    setAlert(true);
  };

  const handleClose3 = () => {
    setAlert(false);
    setMember("");
  };

  const getParishList = async () => {
    setLoadData(true);
    await authApi
      .getPerishList()
      .then((response: any) => {
        setParishList(sortParishesByName(response.data));
      })
      .catch((error: any) => {
        toast.error(error.toString());
      })
      .finally(() => {
        setLoadData(false);
      });
  };

  const retreatDisabledForMem = async () => {
    await committeeApi
      .retreatDisabledForMem(member)
      .then(async (res) => {
        if (res.success) {
          allCommitteMembers();
          handleClose3();
          toast.success(res.msg);
          
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const handleshow5 = (parishData) => {
    setMember(parishData);
    setShow5(true);
  };

  const handleClose5 = () => {
    setShow5(false);
    setMember("");
  };

  const deleteParishMembers = async () => {
    await committeeApi
      .deleteParishMembers({ parishId: member.parishId })
      .then(async (res) => {
        if (res.success) {
          allCommitteMembers();
          handleClose5();
          toast.success(res.msg);
          
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const filterParishesWithRetreats = () => {
    const retreatParishIds = retreatOptions.map((retreat) => retreat.parishId);
    const filteredParishList = parishList.filter((parish) =>
      retreatParishIds.includes(parish.id)
    );
    setParishList(filteredParishList);
  };

  const createNewSteeringMember = (parishdata) => {
    setOpenModalFor("NewSteeringMember");
    setShowREgModal(true);
    setSelectUserCheck(false);
    setData({
      retreats: parishdata.retreatIds,
      parishId: parishdata.parishId,
    });
  };

  const query = searchQuery.trim().toLowerCase();
  const committeeEntries = allCommittee ? Object.entries(allCommittee) : [];
  const steeringCount = committeeEntries.length;
  const superAdminCount = allAdminList?.length || 0;
  const subAdminCount = allSubAdminList?.length || 0;
  const retreatCount = allRetreatSubAdminList?.length || 0;

  const filteredCommittee = useMemo(() => {
    return committeeEntries
      .map(([parishName, parishData]: [string, any]) => {
        const parishHit = !query || textMatch(parishData?.parishName || parishName, query);
        const users = parishData?.users || [];
        const visibleUsers = parishHit
          ? users
          : users.filter((user: any) =>
              textMatch(`${user.firstName} ${user.lastName} ${user.email}`, query)
            );
        return [parishName, { ...parishData, users: visibleUsers }];
      })
      .filter(([, parishData]: [string, any]) => {
        if (!query) return true;
        return (
          textMatch(parishData?.parishName, query) ||
          (parishData?.users || []).length > 0
        );
      });
  }, [allCommittee, query]);

  const filteredAdmins = useMemo(() => {
    if (!query) return allAdminList || [];
    return (allAdminList || []).filter((item) =>
      textMatch(`${item.firstName} ${item.lastName} ${item.email}`, query)
    );
  }, [allAdminList, query]);

  const filteredSubAdmins = useMemo(() => {
    if (!query) return allSubAdminList || [];
    return (allSubAdminList || []).filter((item) =>
      textMatch(`${item.firstName} ${item.lastName} ${item.email}`, query)
    );
  }, [allSubAdminList, query]);

  const filteredRetreats = useMemo(() => {
    if (!query) return allRetreatSubAdminList || [];
    return (allRetreatSubAdminList || []).reduce((acc: any[], item: any) => {
      const metaHit = textMatch(
        `${item.parishName} ${item.language} ${item.location} ${item.id} ${item.title}`,
        query
      );
      const matchingSubs = (item.subAdmins || []).filter((sub: any) =>
        textMatch(`${sub.name} ${sub.email} ${sub.role}`, query)
      );
      if (metaHit) acc.push(item);
      else if (matchingSubs.length) acc.push({ ...item, subAdmins: matchingSubs });
      return acc;
    }, []);
  }, [allRetreatSubAdminList, query]);

  const sectionMeta =
    activeTab === "superAdmins"
      ? { id: "super-admins", title: "Super Admins", placeholder: "Search super admins..." }
      : activeTab === "subAdmins"
        ? { id: "sub-admins", title: "Sub Admins", placeholder: "Search sub admins..." }
        : activeTab === "retreatSubAdmins"
          ? {
              id: "retreat-sub-admins",
              title: "Retreat Sub Admins",
              placeholder: "Search retreats or sub admins...",
            }
          : {
              id: "steering-committee",
              title: "Steering Committee",
              placeholder: "Search parish or member...",
            };

  const selectTab = (key: string) => {
    setActiveTab(key);
    setSearchQuery("");
  };

  return (
    <MasterPageShell>
    <div className={styles.page}>
      <div className={styles.statsGrid}>
        <button
          type="button"
          className={`${styles.statCard} ${activeTab === "steeringCommittee" ? styles.statCardActive : ""}`}
          onClick={() => selectTab("steeringCommittee")}
        >
          <span className={styles.statIcon} style={{ background: "#e8f3fc" }}>
            <Users size={20} color="#285d8f" />
          </span>
          <span className={styles.statCopy}>
            <span className={styles.statValue}>{steeringCount}</span>
            <span className={styles.statLabel}>Steering Committee</span>
          </span>
        </button>
        <button
          type="button"
          className={`${styles.statCard} ${activeTab === "superAdmins" ? styles.statCardActive : ""}`}
          onClick={() => selectTab("superAdmins")}
        >
          <span className={styles.statIcon} style={{ background: "#eef6ff" }}>
            <Shield size={20} color="#285d8f" />
          </span>
          <span className={styles.statCopy}>
            <span className={styles.statValue}>{superAdminCount}</span>
            <span className={styles.statLabel}>Super Admins</span>
          </span>
        </button>
        <button
          type="button"
          className={`${styles.statCard} ${activeTab === "subAdmins" ? styles.statCardActive : ""}`}
          onClick={() => selectTab("subAdmins")}
        >
          <span className={styles.statIcon} style={{ background: "#eafaf0" }}>
            <Users size={20} color="#1f8a4c" />
          </span>
          <span className={styles.statCopy}>
            <span className={styles.statValue}>{subAdminCount}</span>
            <span className={styles.statLabel}>Sub Admins</span>
          </span>
        </button>
        <button
          type="button"
          className={`${styles.statCard} ${activeTab === "retreatSubAdmins" ? styles.statCardActive : ""}`}
          onClick={() => selectTab("retreatSubAdmins")}
        >
          <span className={styles.statIcon} style={{ background: "#e6fbfb" }}>
            <MapPin size={20} color="#0b7c7d" />
          </span>
          <span className={styles.statCopy}>
            <span className={styles.statValue}>{retreatCount}</span>
            <span className={styles.statLabel}>Retreat Sub Admins</span>
          </span>
        </button>
      </div>

      <div className={styles.panel}>
        {loadData ? (
          <div className={styles.overlay}>
            <Spinner animation="border" variant="primary" />
          </div>
        ) : null}

        <div className={styles.toolbar}>
          <h4 id={sectionMeta.id} className={styles.sectionTitle}>
            {sectionMeta.title}
          </h4>
          <div className={styles.searchWrap}>
            <MasterSearchField
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder={sectionMeta.placeholder}
            />
          </div>
          {activeTab === "steeringCommittee" ? (
            <Button
              className={styles.addButton}
              onClick={() => {
                setShowREgModal(true);
                clearfield();
                setSelectUserCheck(false);
                filterParishesWithRetreats();
              }}
            >
              <Plus size={16} /> Add Steering Committee
            </Button>
          ) : null}
        </div>

        {activeTab === "steeringCommittee" ? (
          <>
              {filteredCommittee && filteredCommittee.length > 0 ? (
                filteredCommittee.map(
                  ([parishName, parishData], parishIdx) => (
                    <div key={parishIdx} className={styles.groupCard}>
                      <div className={styles.groupHeader}>
                        <div className={styles.groupTitleWrap}>
                          <Building2 size={18} color="#285d8f" />
                          <h5 className={styles.groupTitle}>
                            {parishData.parishName || parishName}
                          </h5>
                          <span className={styles.countChip}>
                            {(parishData.users || []).length}
                          </span>
                        </div>
                        <div className={styles.groupActions}>
                          <button
                            className={styles.actionBtn}
                            onClick={() => createNewSteeringMember(parishData)}
                            title="Add Member"
                            type="button"
                          >
                            <Plus size={16} />
                            <span className={styles.actionLabel}>Add Member</span>
                          </button>
                          <button
                            className={`${styles.actionBtn} ${styles.actionDanger}`}
                            onClick={() => handleshow5(parishData)}
                            title="Delete Parish Steering Members"
                            type="button"
                          >
                            <Trash2 size={16} />
                            <span className={styles.actionLabel}>Remove</span>
                          </button>
                        </div>
                      </div>

                      <div className={styles.groupBody}>
                        {parishData.users.length > 0 ? (
                          parishData.users.map((user, idx) => (
                            <div key={idx} className={styles.personCard}>
                              <div className={styles.personMain}>
                                <div className={styles.avatar}>
                                  {getInitials(user.firstName, user.lastName)}
                                </div>
                                <div className={styles.personCopy}>
                                  <h6 className={styles.personName}>
                                    {user.firstName} {user.lastName}
                                  </h6>
                                  <div className={styles.personMeta}>
                                    <span className={styles.metaItem}>
                                      <Mail size={13} />
                                      {user.email || "N/A"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className={styles.actions}>
                                <button
                                  type="button"
                                  className={styles.actionBtn}
                                  title="Send reset password link"
                                  onClick={() =>
                                    handleShow2(user, "Committee Member")
                                  }
                                >
                                  <Mail size={15} />
                                  <span className={styles.actionLabel}>Send reset link</span>
                                </button>
                                <button
                                  type="button"
                                  className={`${styles.actionBtn} ${styles.actionDanger}`}
                                  title="Remove Member"
                                  onClick={() =>
                                    deleteMemberPopUpOpen(user, parishData)
                                  }
                                >
                                  <Trash2 size={15} />
                                  <span className={styles.actionLabel}>Remove</span>
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p className={styles.mutedNote}>No members added yet.</p>
                        )}
                      </div>
                    </div>
                  )
                )
              ) : (
                <div className={styles.empty}>
                  <div className={styles.emptyIcon}>
                    <Info size={20} color="#285d8f" />
                  </div>
                  {query
                    ? "No matches for your search."
                    : "No Steering Committee members found."}
                </div>
              )}
          </>
        ) : null}

        {activeTab === "superAdmins" ? (
          <>
              <div className={styles.addBar}>
                <div className={styles.addSelect}>
                  <Select
                    id="couple"
                    name="couple"
                    placeholder="Select Couple"
                    menuPlacement="top"
                    isSearchable
                    options={allcouple}
                    onChange={(val) => handleSelectOption(val, "forAdmins")}
                    value={coupleSelectAdmin}
                  />
                </div>
                <Button
                  className={styles.addButton}
                  title="Add Super Admin"
                  onClick={() => handleSelectSubmit()}
                >
                  <Plus size={16} /> Add
                </Button>
              </div>

              {filteredAdmins && filteredAdmins.length > 0 ? (
                <div className={styles.listStack}>
                {filteredAdmins.map((item) => {
                  const isProtected = [
                    "tkolkebeck@me.com",
                    "jimmieflores@gmail.com",
                    "dulceaflores@gmail.com",
                    "kolkebeckd@gmail.com",
                    userData.email,
                  ].includes(item.email);

                  return (
                    <div className={styles.personCard} key={item.id}>
                      <div className={styles.personMain}>
                        <input
                          disabled={isProtected}
                          type="checkbox"
                          className="form-check-input"
                          onChange={(e) => handleShowAlert(e, item)}
                          value={item.id}
                          checked={item.isDisabled !== 1}
                        />
                        <div className={styles.avatar}>
                          {getInitials(item?.firstName, item?.lastName)}
                        </div>
                        <div className={styles.personCopy}>
                          <h6 className={styles.personName}>
                            {item?.firstName || ""} {item?.lastName || ""}
                          </h6>
                          <div className={styles.personMeta}>
                            <span className={styles.metaItem}>
                              <Mail size={13} />
                              {item?.email || "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={styles.actions}>
                        <button
                          type="button"
                          className={styles.actionBtn}
                          onClick={() => handleShow2(item, "Super Admin")}
                          title="Send reset password link"
                        >
                          <Mail size={15} />
                          <span className={styles.actionLabel}>Send reset link</span>
                        </button>
                        {!isProtected && (
                          <button
                            type="button"
                            className={`${styles.actionBtn} ${styles.actionDanger}`}
                            onClick={() => handleShow(item, "Super Admin")}
                            title="Delete Admin"
                          >
                            <Trash2 size={15} />
                            <span className={styles.actionLabel}>Remove</span>
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })
                }
                </div>
              ) : (
                <div className={styles.empty}>
                  <div className={styles.emptyIcon}>
                    <Info size={20} color="#285d8f" />
                  </div>
                  {query ? "No matches for your search." : "No super admins available."}
                </div>
              )}
          </>
        ) : null}

        {activeTab === "subAdmins" ? (
          <>
              <div className={styles.addBar}>
                <div className={styles.addSelect}>
                  <Select
                    id="couple"
                    name="couple"
                    placeholder="Select Couple"
                    menuPlacement="top"
                    isSearchable
                    options={allcouple}
                    value={coupleSelectSubAdmin}
                    onChange={(val) => handleSelectOption(val, "forSubAdmin")}
                  />
                </div>
                <Button
                  className={styles.addButton}
                  title="Add Sub Admin"
                  onClick={() => handleSelectSubmit()}
                >
                  <Plus size={16} /> Add
                </Button>
              </div>

              {filteredSubAdmins && filteredSubAdmins.length > 0 ? (
                <div className={styles.listStack}>
                {filteredSubAdmins.map((item) => {
                  const isSelf = item.email === userData.email;

                  return (
                    <div className={styles.personCard} key={item.id}>
                      <div className={styles.personMain}>
                        <input
                          disabled={isSelf}
                          type="checkbox"
                          className="form-check-input"
                          onChange={(e) => handleShowAlert(e, item)}
                          value={item.id}
                          checked={item.isDisabled !== 1}
                        />
                        <div className={styles.avatar}>
                          {getInitials(item?.firstName, item?.lastName)}
                        </div>
                        <div className={styles.personCopy}>
                          <h6 className={styles.personName}>
                            {item?.firstName || ""} {item?.lastName || ""}
                          </h6>
                          <div className={styles.personMeta}>
                            <span className={styles.metaItem}>
                              <Mail size={13} />
                              {item?.email || "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={styles.actions}>
                        <button
                          type="button"
                          className={styles.actionBtn}
                          onClick={() => handleShow2(item, "Sub-Admin")}
                          title="Send reset password link"
                        >
                          <Mail size={15} />
                          <span className={styles.actionLabel}>Send reset link</span>
                        </button>
                        {!isSelf && (
                          <button
                            type="button"
                            className={`${styles.actionBtn} ${styles.actionDanger}`}
                            onClick={() => handleShow(item, "Sub-Admin")}
                            title="Delete Sub Admin"
                          >
                            <Trash2 size={15} />
                            <span className={styles.actionLabel}>Remove</span>
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })
                }
                </div>
              ) : (
                <div className={styles.empty}>
                  <div className={styles.emptyIcon}>
                    <Info size={20} color="#285d8f" />
                  </div>
                  {query ? "No matches for your search." : "No sub admins available."}
                </div>
              )}
          </>
        ) : null}

        {activeTab === "retreatSubAdmins" ? (
          <>
              {filteredRetreats && filteredRetreats.length > 0 ? (
                filteredRetreats.map((item, index) => (
                  <div key={index} className={styles.groupCard}>
                    <div className={styles.groupHeader}>
                      <div>
                        <h5 className={styles.groupTitle}>
                          <a
                            href={`/retreatRoster?retreatId=${item.id}`}
                            className={styles.groupLink}
                          >
                            {item?.parishName}
                            {item.language
                              ? ` (${item.language[0].toUpperCase()}${item.language.slice(1)}) `
                              : null}{" "}
                            {item.location
                              ? `${item.location[0].toUpperCase()}${item.location.slice(1)}`
                              : ""}
                          </a>
                        </h5>
                        <div className={styles.groupMeta}>
                          <span className={styles.chip}>
                            <strong>ID:</strong>&nbsp;{item.id}
                          </span>
                          <span className={styles.chip}>
                            <strong>Language:</strong>&nbsp;
                            {item.language
                              ? item.language.charAt(0).toUpperCase() +
                                item.language.slice(1)
                              : ""}
                          </span>
                          <span className={styles.chip}>
                            <strong>Dates:</strong>&nbsp;
                            {formatRetreatDates(item.dateFrom, item.dateTo)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={styles.groupBody}>
                    {item.subAdmins && item.subAdmins.length > 0 ? (
                      item.subAdmins.map((subAdmin, subIndex) => (
                        <div className={styles.personCard} key={subIndex}>
                          <div className={styles.personMain}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              onChange={() =>
                                showRetreatAdminAlert(item, subAdmin)
                              }
                              value={subAdmin.id}
                              checked={!subAdmin.isDisabled}
                            />
                            <div className={styles.avatar}>
                              {getInitials(undefined, undefined, subAdmin.name)}
                            </div>
                            <div className={styles.personCopy}>
                              <h6 className={styles.personName}>
                                {subAdmin.name}
                                {subAdmin.role ? (
                                  <span className={styles.roleBadge}>
                                    {subAdmin.role}
                                  </span>
                                ) : null}
                              </h6>
                              <div className={styles.personMeta}>
                                <span className={styles.metaItem}>
                                  <Mail size={13} />
                                  {subAdmin.email || "N/A"}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className={styles.actions}>
                            <button
                              type="button"
                              className={styles.actionBtn}
                              onClick={() =>
                                handleShow2(subAdmin, "Retreat Sub Admin")
                              }
                              title="Send reset password link"
                            >
                              <Mail size={15} />
                              <span className={styles.actionLabel}>Send reset link</span>
                            </button>
                            <button
                              type="button"
                              className={`${styles.actionBtn} ${styles.actionDanger}`}
                              onClick={() =>
                                handleShowOfAccess(item, subAdmin.email)
                              }
                              title="Delete Retreat Sub Admin"
                            >
                              <Trash2 size={15} />
                              <span className={styles.actionLabel}>Remove</span>
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className={styles.mutedNote}>
                        No sub admins for this retreat.
                      </p>
                    )}
                    </div>
                  </div>
                ))
              ) : (
                <div className={styles.empty}>
                  <div className={styles.emptyIcon}>
                    <Info size={20} color="#285d8f" />
                  </div>
                  {query
                    ? "No matches for your search."
                    : "No retreat sub admins found."}
                </div>
              )}
          </>
        ) : null}
      </div>
      {show ? (
        <DeleteModel
          show={show}
          content={
            <>
              <h5 className="mt-4 fw-bold">{myRoleIs} Detail</h5>
              <div className="p-3 border rounded-3 bg-light shadow-sm">
                <h5 className="mt-4 fw-bold">{myRoleIs} : </h5>
                <div>
                  {(removeId.firstName ||
                    removeId.lastName ||
                    removeId.email) && (
                      <div className="mb-2">
                        {removeId.firstName} {removeId.lastName}
                        {removeId.email && (
                          <span className="text-muted"> – {removeId.email}</span>
                        )}
                      </div>
                    )}
                </div>
              </div>
            </>
          }
          handleClose={handleClose}
          DeleteData={removeRole}
        ></DeleteModel>
      ) : null}
      {removeAccessShow ? (
        <DeleteModel
          show={removeAccessShow}
          content={
            <>
              <h5 className="mt-4 fw-bold">Retreat Sub Admin Detail</h5>
              <div className="p-3 border rounded-3 bg-light shadow-sm">
                <h5 className="mt-4 fw-bold">Retreat Sub Admin : </h5>
                <div>
                  {removeId?.subAdmins && (
                    <div className="mb-2">
                      {(() => {
                        const matchedAdmin = removeId.subAdmins.find(
                          (sub) => sub.email === mailId
                        );
                        return matchedAdmin ? (
                          <span className="text-muted">
                            {matchedAdmin.name}
                          </span>
                        ) : null;
                      })()}
                    </div>
                  )}
                </div>

                <h5 className="mt-4 fw-bold">Retreat : </h5>
                <div>
                  <div>
                    <strong className="text-primary d-block">
                      {removeId.title}
                    </strong>
                    <small className="text-muted ms-3">
                      {moment(removeId.dateFrom).format("MMM DD")} -{" "}
                      {moment(removeId.dateTo).format("MMM DD, YYYY")}
                    </small>
                  </div>
                </div>
              </div>
            </>
          }
          handleClose={handleCloseOfAccess}
          DeleteData={removeAccessFromRetreat}
        ></DeleteModel>
      ) : null}
      {showAccessAlert ? (
        <AlertModal
          cancel={"Cancel"}
          okay={"Okay"}
          show={showAccessAlert}
          handleClose={handleCloseAlert}
          message={`Are you sure you want to ${removeId && removeId.isDisabled === 1 ? "enable" : "disable"
            } this admin?`}
          actionFunction={adminAccess}
          heading={"ALERT!!"}
        />
      ) : null}
      {retAdminAccessAlert ? (
        <AlertModal
          cancel={"Cancel"}
          okay={"Okay"}
          show={retAdminAccessAlert}
          handleClose={closeretAdminAlert}
          message={`Are you sure you want to ${removeId && removeId.isDisabled === 1 ? "enable" : "disable"
            } this admin?`}
          actionFunction={retreatAdminAccess}
          heading={"ALERT!!"}
        />
      ) : null}
      {showMailAlert ? (
        <AlertModal
          show={showMailAlert}
          handleClose={handleClose2}
          message={`Are you sure you want to send the reset password link?`}
          actionFunction={sendLoginDetail}
          cancel={"Cancel"}
          okay={"Okay"}
          heading={"ALERT!!"}
        />
      ) : null}

      <Modal
        show={showRegModal}
        onHide={() => {
          setShowREgModal(false);
          clearfield();
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span className={styles.modalTitle}>
              <Users size={18} color="#285d8f" />
              {selectUserCheck === true ? "Edit" : "Add"} Committee Member
            </span>
          </Modal.Title>
        </Modal.Header>
        <Form
          onSubmit={handleSubmit}
          noValidate
          validated={validated}
          className="forms-sample"
        >
          <Modal.Body>
            <p className={styles.modalHint}>
              Enter Committee Member details here..
            </p>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <Form.Label>Select User</Form.Label>
                <Select
                  id="userId"
                  name="userId"
                  labelledBy="Select"
                  isSearchable={true}
                  isMulti={true}
                  placeholder="Select User"
                  menuPlacement="top"
                  options={allcouple}
                  onChange={(e) => handleSelectUserId(e)}
                  value={selecterdCommittee}
                  required
                />
              </Col>

              {openModalFor !== "NewSteeringMember" && (
                <>
                  <Col lg={12} md={12} sm={12} xs={12} className="mt-2">
                    <Form.Group className="form-group">
                      <Form.Label>Parish</Form.Label>
                      <FormSelect
                        required
                        className="form-control minimal parishListInAmin"
                        size="sm"
                        name="parishId"
                        id="parishId"
                        placeholder="Parish"
                        value={data.parishId || ""}
                        onChange={(e) => handleChanges(e)}
                      >
                        <option value="">Select Parish</option>
                        <optgroup label="Parish">
                          {parishList
                            .filter(
                              (p) =>
                                p.parishCategoryName?.toUpperCase() !== "OTHER"
                            )
                            .map((item, index) => {
                              return (
                                <option key={index} value={item.id}>
                                  {formatParishOptionLabel(item)}
                                </option>
                              );
                            })}
                        </optgroup>
                        <optgroup label="OTHER">
                          {parishList
                            .filter(
                              (p) =>
                                p.parishCategoryName?.toUpperCase() === "OTHER"
                            )
                            .map((item, index) => {
                              return (
                                <option key={`other-${index}`} value={item.id}>
                                  {formatParishOptionLabel(item, {
                                    omitCategory: true,
                                  })}
                                </option>
                              );
                            })}
                        </optgroup>
                      </FormSelect>

                      <Form.Control.Feedback type="invalid">
                        Parish is required!
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="form-group bold "
                  >
                    <Form.Label>Retreats</Form.Label>
                    <Select
                      id="retreat"
                      name="retreat"
                      options={retreatOptions}
                      value={selectedRetreats}
                      onChange={handleSelectRetreat}
                      isSearchable
                      isMulti
                      isDisabled={true}
                      components={{
                        MultiValueRemove: CustomMultiValueRemove,
                      }}
                    />
                  </Col>

                  {selectedEditRetreats && selectedEditRetreats.length > 0 && (
                    <Col
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="form-group bold"
                    >
                      <h5 className={styles.sectionTitle}>
                        Already Selected Retreats
                      </h5>
                      <ul className={styles.selectedList}>
                        {selectedEditRetreats.map((item, index) => (
                          <li key={index} className={styles.selectedItem}>
                            {item.label}
                          </li>
                        ))}
                      </ul>
                    </Col>
                  )}
                </>
              )}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            {userData?.userRole !== "SUBADMIN" && (
              <Button variant="primary" type="submit" className={styles.addButton}>
                Submit
              </Button>
            )}
            <Button
              variant="secondary"
              className={styles.addButton}
              onClick={() => {
                setShowREgModal(false);
                clearfield();
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {deleteMember ? (
        <DeleteModel
          show={deleteMember}
          content={
            <>
              <h5 className="mt-4 fw-bold">Steering Committee Detail</h5>
              <div className="p-3 border rounded-3 bg-light shadow-sm">
                {member?.parishData?.parishName && (
                  <div className="mb-2">
                    <span className="fw-bold">Parish:</span>{" "}
                    {member?.parishData?.parishName}{" "}
                  </div>
                )}
                <h5 className="mt-4 fw-bold">User Detail</h5>
                <div>
                  {(member.userData.firstName ||
                    member.userData.lastName ||
                    member.userData.email) && (
                      <div className="mb-2">
                        {member.userData.firstName} {member.userData.lastName}
                        {member.userData.email && (
                          <span className="text-muted">
                            {" "}
                            – {member.userData.email}
                          </span>
                        )}
                      </div>
                    )}
                </div>
              </div>
            </>
          }
          handleClose={deleteMemberPopUpClose}
          DeleteData={deleteMemberFun}
        ></DeleteModel>
      ) : null}

      {alert ? (
        <AlertModal
          show={alert}
          handleClose={handleClose3}
          message={`Are you sure you want to ${member?.retreat?.disabled === false ? "DISABLE" : "ENABLE"
            } this retreat`}
          actionFunction={retreatDisabledForMem}
          cancel={"Cancel"}
          okay={"Okay"}
          heading={"ALERT!!"}
        />
      ) : null}

      {show5 ? (
        <DeleteModel
          show={show5}
          content={
            <>
              <h5 className="mt-4 fw-bold">Steering Committee Detail</h5>
              <div className="p-3 border rounded-3 bg-light shadow-sm">
                {member.parishName && (
                  <div className="mb-2">
                    <span className="fw-bold">Parish:</span> {member.parishName}{" "}
                  </div>
                )}

                <h5 className="mt-4 fw-bold">Users Detail</h5>
                {member.users.map((user, idx) => (
                  <div>
                    {/* His Details */}
                    {(user.firstName || user.lastName || user.email) && (
                      <div className="mb-2">
                        {user.firstName} {user.lastName}
                        {user.email && (
                          <span className="text-muted"> – {user.email}</span>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </>
          }
          handleClose={handleClose5}
          DeleteData={deleteParishMembers}
        ></DeleteModel>
      ) : null}
    </div>
    </MasterPageShell>
  );
};

export default AdminDashboard;
